const type = 'SET_ACCOUNT_PROGRAM_TYPES';

const setAccountProgramTypes = (data = {}) => ({
  data,
  type,
});

export { type };
export default setAccountProgramTypes;
